import { useMe } from '@/shared/auth/queries'

/**
 * @returns the list of tenants the current user has access to
 */
export const useUserTenants = () => {
	const { data } = useMe()
	return data.allowed_tenants
}
